<template lang="pug">
.content-wrap
  .content-top
    .con
      .gbox-wrap.overflow-hidden
        .news-list-wrap.text-white
          .news-listbox
            .iimg
              img(src="/new/img/article/jackpot.png")
              a.btn-submit.btn-custom.text-white.w-100(v-if="!$store.getters.isLoggedIn" href='javascript:void(0);' @click="$helpers.openModal('#regModal')") Signup Now
            .ccon
              h1 EpicWin Philippines Casino: Game Selection, Bonuses, and Features
              p Your exhilarating gaming experience begins at 
                router-link.text-decoration-underline.text-info(to="/" target="_blank") EpicWin Philippines
                |  . 
                b Rest
                |  assured, there is no shortage of entertainment options to put a smile on your face, whether seeking to ‘win big’, ‘try out new slots’, or unwind after work with a few spins. EpicWin ensures that you're rewarded and entertained every step of the way.
              p The EpicWin hallmark is powered by more than the latest designs and buzz-worthy slot titles. Our innovative gameplay and EpicWin intuitive user interface, paired with relevant casino bonuses, drive real value to real players like you.
              p No complicated terms. No waiting games. Just fast play, fun titles, and flexible rewards. Whether you’re into classic fruit slots, vibrant video slots, or JILI-powered favorites, this is your online casino home base. The moment you step in, you're not just a player—you’re part of a community that wins together.
              h2 Diverse Game Selection
              p EpicWin Philippines feels and looks like an arcade, brimming with engaging online casino games. EpicWin offers a diverse catalog of online casino games, including slot machines, live dealer games, and much more. Looking for a place to try your luck? EpicWin has got you covered!
              p Enjoying slot machine games? You can choose from our wide range of classic and video fruit slots. Looking for a more interactive gaming experience? Join our live casino games featuring blackjack, baccarat, roulette, and more through vivid streams and interactive hosts.
              p Also, take note of other game categories such as mini games and scratch cards or other game themed titles, which offer variety and ever-evolving entertainment. As you navigate the site, everything flows smoothly with no friction. Each option you want to select takes only a few clicks.
              h2 Bonuses That Add Real Value
              p The bonuses offered at EpicWin Philippines are not merely for show; they serve a genuine purpose: to improve your gaming experience. EpicWin ensures that the offers available are tailored to your preferences upon signup.
              h3 1) Welcome Bonus
              p Just joined EpicWin? We are here to offer you with your first deposit at EpicWin through a percentage match bonus. We automatically boost your balance as its percentage is matched, hence it is referred to as a welcome bonus. No strings attached bonus, more funds translate to more spins and higher winning possibilities.
              h3 2) Free Credit Drops
              p We believe surprise rewards keep things exciting. During festivals, significant sports events, or even on random weekends, we drop bonus credits into your account—no deposit needed. It’s our way of saying thanks for showing up and playing.
              h3 3) Daily & Weekly Promotions
              p There is always something to look forward to during the week. Get ready for daily spin boosts, enjoy weekend reload bonuses, and boost your bankroll. We center these 
                router-link.text-decoration-underline.text-info(to="/promotions" target="_blank") promotions
                |  around popular Online Casino Games, so expect tailored promotional boosts that enhance your gameplay.
              h3 4) Tournaments & Jackpots
              p If you feel competitive, you could participate in our slot tournaments packed with thrilling competitions and exciting prize pools. Join and compete on the weekly or seasonal leaderboards. Alternatively, you could try your luck at progressive jackpots, waiting to be claimed by someone, and that someone could be you, as they continue growing until someone wins.
              h3 5) VIP Rewards
              p Our loyalty program, VIP Benefits, offers even greater advantages over other programs. In this case, your expenditures and activities allow you to reach different levels in the VIP system, which has benefits like specialized assistance, prioritized withdrawal processing, personalized cashback percentages, and invitation-only offers. Rewards increase as participation increases.
              p Every bonus is clearly explained so you know exactly what you’re getting. It’s all about generous, transparent rewards.
              h2 Standout Features for Players
              p We’ve designed 
                b EpicWin Philippines
                |  to feel welcoming, powerful, and fun—here’s how:
              h3 1) Licensed & Secure
              p At 
                b EpicWin Philippines
                | , trust is non-negotiable. That’s why we only feature games from certified and regulated developers, ensuring that every spin, win, and payout is fair and transparent. Your data is protected using bank-grade encryption, while all gameplay runs on audited RNG (Random Number Generator) systems for authenticity. We're not just secure—we're certified safe, so you can focus on having fun, not worrying about safety.
              h3 2) Smooth Deposits & Quick Cash-Outs
              p We know that waiting for money ruins the fun. That’s why we’ve made deposits and withdrawals incredibly easy. Every transaction is quick and hassle-free, whether you use GCash, PayMaya, bank transfer, or other local e-wallets. Most withdrawals are processed within minutes, and our system keeps your funds and records completely secure. No delays. No red tape. Just fast, reliable payments designed around you.
              h3 3) Mobile-First Experience
              p Gaming on the go is second nature to most Filipino players, and we built 
                b EpicWin Philippines
                |  with that in mind. Our site is fully responsive, meaning you can enjoy your favorite slots and online casino games from any smartphone or tablet, without needing to download an app. Everything runs smoothly, even on slower networks. It’s plug-and-play wherever you are—whether at home, commuting, or just lounging around.
              h3 4) 24/7 Customer Support
              p Have a question? Hit a snag with a bonus? Want help verifying your withdrawal? Our customer support team is available 24/7 and is always manned by real people, not bots. Whether you reach out through live chat, email, or hotline, we ensure your concerns are answered quickly and with real solutions. At EpicWin, your comfort and satisfaction are always a top priority, no matter the time of day.
              h2 Why Choose EpicWin Philippines?
              p At 
                b EpicWin Philippines
                | , we don’t just provide a place to play—we deliver an online casino experience built for real players. Here’s why thousands are making the switch every day:
              ul
                li
                  b Massive Game Variety:
                  |  We feature a handpicked collection of 
                  b online casino games
                  | , including hit JILI slots, arcade 
                  router-link.text-decoration-underline.text-info(to="/fishing" target="_blank") fishing
                  |  titles, card games, and live dealer experiences. Whether you’re into simple fun or high-stakes thrills, there’s always something new to try.
                li
                  b Transparent and Rewarding Bonuses:
                  |  Our  
                  b casino bonuses
                  |  are made with you in mind and are easy to understand and use. Every reward has real value, from free credit drops to daily top-ups and exciting jackpot events.
                li
                  b Seamless User Experience:
                  |  No lag. No complicated menus. Just smooth, fast-loading games that adapt perfectly to any mobile or desktop screen. You’ll love how effortless it is to jump in and start winning.
                li
                  b Instant, Hassle-Free Payouts:
                  |  Withdraw your winnings through GCash, PayMaya, or bank transfer—fast and secure. Most cash-outs are processed within minutes, so your rewards are always within reach.
                li
                  b Mobile-Friendly by Design:
                  |  Play wherever, whenever. Our platform is optimized for 
                  b Filipino mobile users
                  | , so you can spin the reels, shoot the fish, or join a tournament from the palm of your hand.
                li
                  b Round-the-Clock Support:
                  |  Need help at 2 AM? No problem. Our 24/7 live support team can assist you with anything, from game queries to payment clarifications.
                li
                  b Localized for Filipino Players:
                  |  From promotions tailored to local holidays to Philippines-friendly payment methods, EpicWin is built for your lifestyle, language, and needs.
              h2 Final Thoughts
              p EpicWin Philippines is more than a gaming destination; it’s a community built for enjoyment, opportunity, and trust. We're here to give you top-tier entertainment with a significant selection of 
                router-link.text-decoration-underline.text-info(to="/casino" target="_blank") Online Casino Games
                | , clear and rewarding casino bonuses, and robust protective features.
              p Play confidently, enjoy responsibly, and grab every bonus chance while you’re at it. Welcome to EpicWin—where excitement meets reliability!
              h2 FAQ's
              p
                b 1) What types of games can I play at EpicWin Philippines?
                br
                | Slots, fishing games, live casino, and more—all from top providers like JILI, SpadeGaming, and Mega888.
              p
                b 2) Is there a welcome bonus for new players?
                br
                | Yes! New players receive a Free 100 Credit No Deposit Bonus upon signing up.
              p
                b 3) Can I withdraw my winnings using GCash?
                br
                | Absolutely. We support fast withdrawals via GCash, PayMaya, and local banks.
              p
                b 4) Is the platform mobile-friendly?
                br
                | Yes, our entire site and games are optimized for Android and iOS devices—no downloads needed.
              p
                b 5) How do I join VIP or loyalty programs?
                br
                | Once you start playing, you’re automatically tracked for VIP progress. No forms, no hassle—just rewards.
    footerInfo(:target="'/game-selection-bonuses-and-features'")
</template>
<script>
import config from "@/config";
import footerInfo from '@/views/default/_footerArticle.vue'
export default {
  components:{
    footerInfo
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
			loading:false,
      showMobile: false,
    }
  },
  created(){
    window.scroll(0,0)
		$('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}/game-selection-bonuses-and-features`);
    this.getSeo("game-selection-bonuses-and-features")
		// this.checkSize()
    // var vm = this
    // $(window).resize(function () {
    //   vm.checkSize()
    // });
	},
  methods:{
    getSeo(page){
      let page_name = page
      this.$store
        .dispatch("user/getSeo", {page_name})
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success
          if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
						}
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }       
          }
        })
        .catch(response => {
          this.loading = false;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          }
        });
    },
    checkSize(){
      if ($(window).width() < 681) {
        this.showMobile = true
      }else{
        this.showMobile = false
      }
    },
  }
}
</script>